import { useState, useEffect, useCallback, useRef } from "react";
import "../vendor/vendorList.css";
import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as LocationIc } from "../../assets/svg/location_ic.svg";
import { ReactComponent as PhoneIc } from "../../assets/svg/phone_ic.svg";
import { ReactComponent as MailIC } from "../../assets/svg/mail_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import profileIc from "../../assets/png/profile-ic.png";
import { Dropdown, Toast, ToastContainer } from "react-bootstrap";
import SearchableDropdown from "../common/commonDropDown";
import ReactPaginate from "react-paginate";

import Loader from "../common/loader";
import LoaderModal from "../common/loader";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { ReactComponent as EditIc } from "../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../assets/svg/delete_ic.svg";
import { ReactComponent as CalenIc } from "../../assets/svg/calen_ic.svg";
import { getPurchaseReqListApi, getStatusApi, updateStageApi } from "./pr-api";
import productDefault from "../../assets/png/product_default.png";
import { format } from "date-fns";
import { useGlobal } from "../../GlobalContext";
import ProfileImageModal from "../common/common-preview";
function PurchaseReqListingPage() {
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  // variable initial
  const isFirstRender = useRef(true);
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [stageSelect, setStageSelect] = useState({
    value: "",
    label: "All",
  });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [productSelect, setProductSelect] = useState(null);
  const [vendorSelect, setVendorSelect] = useState(null);
  const [statusSelect, setStatusSelect] = useState(null);
  const [active, setActive] = useState("list");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [stageOption, setStageOption] = useState([]);
  const [stageListOption, setListStageOption] = useState([]);
  const [sortByOption, setSortByOption] = useState([
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ]);
  const [purchaseReqList, setPurchReqList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  // handle
  const handleSelectProduct = (option) => {
    console.log("Selected option:", option);
    setProductSelect(option);
  };
  const handleSelectVendor = (option) => {
    console.log("Selected option:", option);
    setVendorSelect(option);
  };
  const handleSelectStatus = (option) => {
    console.log("Selected option:", option);
    setStatusSelect(option);
  };
  const handleClearProduct = () => {
    setProductSelect(null);
  };
  const handleClearVendor = () => {
    setVendorSelect(null);
  };
  const handleClearStatus = () => {
    setStatusSelect(null);
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };

  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  // useEffect

  useEffect(() => {
    getReqStages();
  }, []);
  useEffect(() => {
    getPurchaseReqList();
  }, [
    itemsPerPage,
    itemOffset,
    search,
    selectedSortby,
    stageSelect,
    statusSelect,
    vendorSelect,
    productSelect,
    startDateSave,
    endDateSave,
  ]);

  // Api

  const updateStage = async (id, value) => {
    setIsLoading(true);
    const bodyData = {
      status: value,
    };
    try {
      const response = await updateStageApi(id, bodyData);
      console.log("response....", response);
      if (response.data.success === true) {
        getPurchaseReqList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getReqStages = async () => {
    try {
      const response = await getStatusApi();
      if (response.data.success === true) {
        setListStageOption([
          { value: "", label: "All" },
          ...response.data.suggestionlist,
        ]);

        setListStageOption(response.data.suggestionlist);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getPurchaseReqList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "Created",
      "desc",
    ];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      status: statusSelect?.value ?? "",
      part_id: productSelect?.value ?? "",
      vendor_id: vendorSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getPurchaseReqListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setPurchReqList(response.data.purchase_requests ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />
      <LoaderModal show={isLoading} />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="RFQ" />

        {/* Main Content */}
        <div className="rounded-4 flex-grow-1  ">
          {" "}
          <Navbar pageTitle="RFQ" />
          <div className="bg-half-white p-2">
            <div className="bg-white rounded-4 p-4">
              {" "}
              {/* First Row */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* Left: Heading */}
                <div className="my-heading fs-24 fw-600">
                  RFQ - {totalCount}
                </div>

                {/* Right: Controls */}
                <div className="d-flex flex-wrap gap-3">
                  {/* Search */}
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input
                      type="text"
                      placeholder="Search"
                      className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                      value={search || ""}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>

                  {/* Add New Vendor */}
                  {checkPermission("Purchase Request", "create_permission") && (
                    <div
                      className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => navigate("/pr/create")}
                      style={{
                        height: "40px", // Adjust button height if needed
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} />{" "}
                        {/* ✅ Smaller Icon */}
                      </div>

                      <div
                        className="fs-12 fw-600" // ✅ Reduced text size
                        style={{ lineHeight: "16px" }}
                      >
                        New Request
                      </div>
                    </div>
                  )}

                  {/* Import */}
                  {/* <div className="my-import d-flex align-items-center justify-content-center gap-2">
                  <ImportIc />
                  <div style={{ paddingBottom: "4px" }}>Import</div>
                </div> */}
                </div>
              </div>
              {/* Second Row */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex justify-content-start gap-3">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                        }}
                        title={selectedSortby.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">Sort by :</span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedSortby.label}
                          </span>

                          <span className="dropdown-toggle-arrow textPurple">
                            {/* <DownArrow /> */}
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      {/* <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent onClick from firing
                              setSelectedSortBy(option); // Execute your selection logic
                            }}
                            active={selectedSortby === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu> */}
                    </Dropdown>
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_vendor`}
                      placeholder="Vendor"
                      value={vendorSelect}
                      onSelect={handleSelectVendor}
                      handleClear={handleClearVendor}
                    />
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_parts`}
                      placeholder="Product"
                      value={productSelect}
                      onSelect={handleSelectProduct}
                      handleClear={handleClearProduct}
                    />
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_pr_stages`}
                      placeholder="Status"
                      value={statusSelect}
                      onSelect={handleSelectStatus}
                      handleClear={handleClearStatus}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center px-1"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #EBEBEB",

                      backgroundColor: "white",
                    }}
                  >
                    <span className="fs-12 fw-400 textGrey">Date :</span>
                    <span
                      className="dropdown-text1 textPurple mb-2"
                      style={{ height: "28px" }}
                    >
                      {" "}
                      <DateRangePicker onChange={handleDateChange} />
                    </span>
                  </div>{" "}
                  {/* <div
                  className="d-flex align-items-center px-1"
                  style={{
                    borderRadius: "12px",
                    border: "1px solid #EBEBEB",

                    backgroundColor: "white",
                  }}
                >
                  <span className="fs-12 fw-400 textGrey">Date :</span>
                  <span className="dropdown-text textPurple">
                    {" "}
                    <DateRangePicker onChange={handleDateChange} />
                  </span>
                </div>
                 */}
                </div>
                <div
                  className="rounded-4 toggleBg d-flex mt-2"
                  style={{
                    width: "80px",
                    height: "32px",
                    backgroundColor: "#f1f3f6", // toggle background
                    padding: "4px",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    onClick={() => setActive("list")}
                    className={`d-flex align-items-center justify-content-center rounded-3  ${
                      active === "list" ? "bg-primary1" : ""
                    }`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "list" ? (
                      <ListView style={iconStyle} />
                    ) : (
                      <SelectList style={iconStyle} />
                    )}
                  </div>

                  <div
                    onClick={() => setActive("grid")}
                    className={`d-flex align-items-center justify-content-center rounded-3 ${
                      active === "grid" ? "bg-primary1" : ""
                    }`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "grid" ? (
                      <SelectGrid style={iconStyle} />
                    ) : (
                      <EmailView style={iconStyle} />
                    )}
                  </div>
                </div>
              </div>
            </div>
             {active === "list" && (
              <div className="bg-white rounded-4 mt-3 w-100 p-3 custom-scrollbar-x">
                <div style={{ minWidth: "1200px", width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      flex: "10",
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      height: "44px",
                      backgroundColor: "#F2F2F2",
                    }}
                    className="head3 w-100 justify-content-center align-items-center"
                >
                  {/* <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleChange}
                                style={{ marginRight: "8px", marginBottom: "14px" }}
                              /> */}
                  <p
                    style={{ flex: "1.5", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Request ID
                  </p>
                  <p
                    style={{ flex: "2.0", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Product
                  </p>
                  <p
                    style={{ flex: "2.0", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Vendor
                  </p>{" "}
                  <p
                    style={{ flex: "1.0", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Qty
                  </p>{" "}
                  <p
                    style={{ flex: "1.5", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Exp. delivery date
                  </p>{" "}
                  <p
                    style={{ flex: "2.0", margin: "0px", whiteSpace: "nowrap" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Status
                  </p>{" "}
                </div>
                <div>
                  {(purchaseReqList ?? []).map((item, index) => (
                    <div
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        backgroundColor:
                          hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        cursor: "pointer",
                        height: "44px",
                        minWidth: "1200px",
                        position: "relative",
                        width: "100%",
                      }}
                      onClick={() => {
                        if (
                          checkPermission("Purchase Request", "view_permission")
                        ) {
                          navigate("/pr/view", {
                            state: { id: item.id },
                          });
                        }
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      {" "}
                      {/* <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={handleChange}
                                    style={{ marginRight: "8px", marginBottom: "0px" }}
                                  /> */}
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.5",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.req_no}
                      >
                        {item.req_no ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "2.0",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.part}
                      >
                        <img
                          key={index}
                          src={
                            item.product_image &&
                            item.product_image.trim() !== ""
                              ? item.product_image
                              : productDefault
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedProfile(
                              item.product_image &&
                                item.product_image.trim() !== ""
                                ? item.product_image
                                : productDefault,
                            );
                            setShowProfilePopup(true);
                          }}
                          alt="Profile"
                          className="avatar-item me-1 ms-0"
                        />
                        {item.part ?? "---"}
                      </p>
                      <div
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "2.0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                        title={item.vendor_name}
                      >
                        {" "}
                        <img
                          key={index}
                          src={
                            item.image && item.image.trim() !== ""
                              ? item.image
                              : profileIc
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedProfile(
                              item.image && item.image.trim() !== ""
                                ? item.image
                                : profileIc,
                            );
                            setShowProfilePopup(true);
                          }}
                          alt="Profile"
                          className="avatar-item me-1 ms-0"
                        />
                        {item.vendor_name ?? "---"}
                      </div>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.0",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.quantity}
                      >
                        {item.quantity ?? "0"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1.5",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.expected_delivery_date}
                      >
                        {item.expected_delivery_date ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "2.0",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          margin: "0px",
                        }}
                        title={item.status}
                      >
                        <span
                          className="backgroundYellow mx-2"
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "3px",
                            display: "inline-block",
                          }}
                        ></span>
                        {item.status ?? "---"}
                      </p>
                      {/* {hoveredIndex === index && (
                        <div
                          style={{
                            position: "absolute",
                            // top: "50%",
                            right: "35px",
                            // transform: "translate(-50%, -50%)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/vendor/create", {
                                  state: { id: item.id },
                                });
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                                background: "#FFFFFF",
                                cursor: "pointer",
                                border: "0.8px solid #E5E5E5",
                              }}
                            >
                              <EditIc />{" "}
                            </div>
                            <span style={{ marginLeft: "16px" }}></span>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteId(item.id);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                                background: "#FFFFFF",
                                cursor: "pointer",
                                border: "0.8px solid #E5E5E5",
                              }}
                            >
                              <DeleteIc />{" "}
                            </div>
                          </div>
                        </div>
                      )} */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
            {active === "grid" &&
              purchaseReqList.map((vendor, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center justify-content-between   business-card w-100 p-3 mt-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (
                      checkPermission("Purchase Request", "view_permission")
                    ) {
                      navigate("/pr/view", {
                        state: { id: vendor.id },
                      });
                    }
                  }}
                >
                  <div className="d-flex flex-grow-1  w-25">
                    <div className="profile-wrapper">
                      <img
                        src={
                          vendor.image && vendor.image.trim() !== ""
                            ? vendor.image
                            : productDefault
                        }
                        alt="Profile"
                        className="profile-img"
                      />
                    </div>
                    <div className="d-flex flex-column gap-2 ps-3">
                      <div className="textcolor fs-16 fw-400 ">
                        {vendor.part ?? "-"}
                      </div>
                      <div className="d-flex gap-2  align-items-center">
                        <span className="textGrey fs-12 fw-400">Qty :</span>
                        <span className="textPurple fs-12 fw-500">
                          {vendor.quantity ?? "-"}
                        </span>{" "}
                        <span
                          style={{
                            width: "4px",
                            height: "4px",
                            backgroundColor: "#D9D9D9",
                            borderRadius: "50%",

                            display: "inline-block",
                          }}
                        ></span>
                        <div className="rounded-4 backgroundBlue px-2 py-1 textBlue fs-11 fw-500">
                          <span className="textGrey fs-12 fw-400">
                            Req. No :
                          </span>{" "}
                          <span className="textBlue fs-11 fw-500">
                            {vendor.req_no ?? "-"}
                          </span>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 ps-3 flex-grow-1  w-25">
                    <div className="textltcolor fs-13 fw-400 ">
                      <img
                        src={
                          vendor.image && vendor.image.trim() !== ""
                            ? vendor.image
                            : profileIc
                        }
                        alt="Profile"
                        className="avatar-item me-1 ms-0"
                      />{" "}
                      {vendor.vendor_name ?? "-"}
                    </div>
                    <div className="textltcolor fs-13 fw-400 ">
                      <CalenIc />{" "}
                      <span className="textGrey fs-12 fw-400">Exp. date :</span>{" "}
                      <span className="textcolor fs-11 fw-600">
                        {vendor.expected_delivery_date ?? "-"}
                      </span>{" "}
                    </div>
                  </div>
                  <div className="d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3  w-25">
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between backgroundltprimary rounded-5"
                          style={{
                            padding: "6px 12px",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <span
                              className="backgroundPrimary"
                              style={{
                                width: "10px",
                                height: "10px",
                                borderRadius: "3px",
                                display: "inline-block",
                              }}
                            ></span>

                            <span className="dropdown-text textcolor fs-13 fw-500">
                              {vendor.status ?? "-"}
                            </span>

                            <span className="dropdown-toggle-arrow">
                              {/* <DownArrowIc /> */}
                            </span>
                          </span>
                        </Dropdown.Toggle>

                        {/* <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {stageListOption.map((option) => (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              key={option}
                              onClick={() =>
                                updateStage(vendor.id, option.value)
                              }
                              // active={selected === option}
                            >
                              {option.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu> */}
                      </Dropdown>
                    </div>
                    {/* <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                          style={{
                            width: "36px",
                            height: "36px",
                            border: "1px solid #EBEBEB",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <ThreeDotIC />
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              navigate("/vendor/create", {
                                state: { id: vendor.id },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              setDeleteId(vendor.id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div> */}
                  </div>
                </div>
              ))}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">
                  Records per page: &nbsp;
                </span>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
                >
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="my-2"
                  style={{ minWidth: "unset", width: "30%" }}
                >
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default PurchaseReqListingPage;
